import { PAYMENTS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import paymentsTypes from '../../constants/paymentsTypes'
import { axios } from '../../services'

const payment_receipt_request = () => {
  return {
    type: paymentsTypes.receipt.request
  }
}

const payment_receipt_success = () => {
  return {
    type: paymentsTypes.receipt.success
  }
}

const payment_receipt_failure = (messages) => {
  return {
    type: paymentsTypes.receipt.failure,
    payload: messages
  }
}

const payment_receipt = (payment_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(payment_receipt_request())

    // Request
    axios.get(
      formatRoute(PAYMENTS_ROUTES.receipt, {id: payment_id}),
      {
        responseType: 'blob'
      }
    ).then( response => {
      // success
      const blob = URL.createObjectURL(response.data, "receipt_download_pdf_link")
      const fileLink = document.createElement('a')
      document.body.appendChild(fileLink);
      fileLink.id = "receipt_download_pdf_link"
      fileLink.style="display: none"
      fileLink.href = blob
      fileLink.download = `receipt_${payment_id}.pdf`
      fileLink.click();
      URL.revokeObjectURL(blob)
      const fileAnchor = document.getElementById('receipt_download_pdf_link')
      fileAnchor.parentNode.removeChild(fileAnchor)
      dispatch( payment_receipt_success() )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = [error]
        // errors = ["Error fetching pdf file."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      // console.log(errors)
      dispatch( payment_receipt_failure(errors))
    })
  }
}

export {
  payment_receipt,
}



// WEBPACK FOOTER //
// ./src/js/actions/payments/receipt.js